export default __webpack_public_path__ + "static/SRF Carabrew 6S6902 - Product Specifications & Technical Data-b4821a134f58d0c910bc384d0c21fee9.pdf";